import { render, staticRenderFns } from "./BookGrandTotal.vue?vue&type=template&id=2727f204&scoped=true&"
import script from "./BookGrandTotal.vue?vue&type=script&lang=js&"
export * from "./BookGrandTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2727f204",
  null
  
)

export default component.exports